'use client';

import { useEffect } from 'react';
import { getStore } from '~/mobx/AppStore';

type Props = {
    isUserAlreadyVoted: boolean;
    isUserAdult: boolean;
};

const Client = (props: Readonly<Props>) => {
    const { candidateStore } = getStore();
    const { isUserAlreadyVoted, isUserAdult } = props;

    useEffect(() => {
        const isDisabledVote = isUserAlreadyVoted || !isUserAdult;
        candidateStore.setIsUserAlreadyVoted(isUserAlreadyVoted);
        candidateStore.setIsUserChild(!isUserAdult);
        candidateStore.setIsDisabledVote(isDisabledVote);
    }, [isUserAlreadyVoted, isUserAdult, candidateStore]);

    return null;
};

export default Client;
